import PracticeConfiguration from "components/features/practice/PracticeConfiguration";
import DashboardLayout from "components/layouts/DashboardLayout";

const PracticeConfigurationPage: React.FC = () => {
  return (
    <DashboardLayout title="Practice Configuration">
      <PracticeConfiguration />
    </DashboardLayout>
  );
};

export default PracticeConfigurationPage;
